import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
    clientUrl,
    GET_SINGLE_BRAND,
    GET_BRAND_PRODUCTS,
    ACTIVATE_PROMOTION,
    DEACTIVATE_PROMOTION,
} from '../endPoints';
import { headers } from '../baseUrl/setHeaders';
import { baseURL } from '../baseUrl/baseURL';

export const brandAPI = createApi({
    reducerPath: 'brandAPI',
    baseQuery: fetchBaseQuery({
        baseUrl: baseURL,
        prepareHeaders: headers,
    }),
    endpoints: (builder) => ({
        getSingleBrand: builder.query({
            query: (id) => `${GET_SINGLE_BRAND}${id}`,
        }),
        getBrandProducts: builder.query({
            query: (id) => `${GET_BRAND_PRODUCTS}${id}`,
        }),
        activatePromotion: builder.mutation({
            query: (id) => ({
                url: `${ACTIVATE_PROMOTION}${id}`,
                method: 'POST',
                body: [],
            }),
        }),
        deactivatePromotion: builder.mutation({
            query: (id) => ({
                url: `${DEACTIVATE_PROMOTION}${id}`,
                method: 'POST',
                body: [],
            }),
        }),
    }),
});

export const {
    useGetSingleBrandQuery,
    useGetBrandProductsQuery,
    useActivatePromotionMutation,
    useDeactivatePromotionMutation,
} = brandAPI;
